module.exports = __webpack_public_path__ + "img/online-payment.9402a782.svg";